import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import SubmitButton from 'Components/Form/SubmitButton'

const IconButton = props => {
  return (
    <SubmitButton variant="contained" {...props}>
      {props.children}
    </SubmitButton>
  )
}
export default withStyles(styles)(IconButton)



// WEBPACK FOOTER //
// ./src/Components/Form/StyledIconButton/index.js